// Hack for Next.js Link component which is removing any trailing slashes if no trailingSlash: true set in next.config.js
// It adds double trailing slash
export function deprecatedAddTrailingSlashes(href: string): string {
  return href;
  // return href ? href.replace(/^([^?#]+)/, (match) => match.replace(/\/*$/, '//')) : href;
}

export function getUrlFromFetchInput(input: Parameters<typeof fetch>[0]) {
  return input instanceof Request ? input.url : input.toString();
}
